// initial state
import * as base from './base.js'
const baseName = '/admin/api/operator'

const obj = base.setBaseUrl('operator', baseName)
const a = Object.assign(obj, {})
export default a
